/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const core: Readonly<Record<string, string>> = {};
